import api from 'api';
import makeSorter from 'lib/makeSorter';
import { message } from 'antd';
import { regexpSearch } from 'lib/searchFns';
import ___ from '../constants';
import { result } from 'lodash';
import { matchesExactFields, matchesIncludeFields, subtractFields } from '../shared/searchUtilites';
import Cookies from 'js-cookie';

const dateColumns = [
    'est_arrival_date',
]

const initialState = {
    originalOrders: [],
    loading: false,
    loadingDetails: false,
    searchLoading: false,
    sendingTo: false,
    currentEditRow: null,
    currentEditHeader: null,
    originalEditRow: null,
    detailLines: null,
    searchValue: '',
    filters: {
        sendTo: null,
        warehouse: null,
        status: null,
    },
    sortField: null,
    sortOrder: null,
    warehouseOptions: [],
};

export const types = {
    SET_STATE: 'INCOMING/SET_STATE',
    SET_SEARCH_VALUE: 'INCOMING/SET_SEARCH_VALUE',
    SET_SORT: 'INCOMING/SET_SORT',
    UPDATE_ORDER: 'INCOMING/UPDATE_ORDER'
};

export const reducers = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_STATE:
            // DEBUG console.log('[Reducer] SET_STATE:', action.data);
            return { ...state, ...action.data };


        case types.SET_SEARCH_VALUE:
            return {
                ...state,
                searchValue: action.data,
            };

        case types.SET_SORT:
            return {
                ...state,
                sortField: action.data.field,
                sortOrder: action.data.order,
            };

        case types.UPDATE_ORDER:
            return {
                ...state,
                orders: state.orders.map(ord =>
                    ord.SODocEntry === action.data.docEntry
                        ? {
                            ...ord,
                            [action.data.property]:
                                action.data.value
                        }
                        : ord
                )
            };

        default:
            return state;
    }
};


export const selectOrders = state =>
    state.warehouse.originalOrders;

export const actions = {
    setState: (data) => ({ type: types.SET_STATE, data }),

    setSearchValue: (value) => ({
        type: types.SET_SEARCH_VALUE,
        data: value,
    }),
    
    setSort: (value) => ({
        type: types.SET_SORT,
        data: value,
    }),

    updateOrder: (data) => ({ type: types.UPDATE_ORDER, data }),

    setCurrentEditRow: (row) => async (dispatch, getState) => {
        //console.log('[Incoming.redux.js] setCurrentEditRow');
        //console.log(row);
        dispatch({
            type: types.SET_STATE,
            data: {
                currentEditRow: row,
            },
        });
    },

    getIncoming: () => async (dispatch, getState) => {
        console.log('[Incoming.redux.js] getIncoming()');
        const state = getState();
        let LastSystem = Cookies.get('LastSystem');

        dispatch(actions.setState({ loading: true }));

        try {
            console.log('selectedSystem', state.auth.selectedSystem);

            // QUERY Warehouse.GetInbound
            let result = await api.get('/warehouse/receiving', {
                params: {
                    system: state.auth.selectedSystem ?? LastSystem // 'NO_SYS'
                }
            });
            //console.log(result)
            //console.log(result.incomingOrders.recordset)
            let _result = result.incomingOrders.recordset;

            const _arrayResult = [];
            for (let [key, value] of Object.entries(_result)) {
                //console.log(key, value);
                _arrayResult.push(value)
            }
            //console.log(_arrayResult)

            dispatch(actions.setState({
                originalOrders: _arrayResult,
                loading: false
            }));
        } catch (err) {
            console.log('getIncoming catch err')
            console.error(err);
            dispatch(actions.setState({
                originalOrders: [],
                loading: false
            }));
        }
    },


    getIncomingPODetails: () => async (dispatch, getState) => {
        console.log('[Incoming.redux.js] getIncomingPODetails()');
        const state = getState().warehouse;
        dispatch(actions.setState({ loading: true }));

        //console.log(state.currentEditRow)
        //console.log(state.currentEditRow.docKey)
        //console.log(state.currentEditRow.docEntry)
        //console.log(typeof state.currentEditRow.docKey)

        try {
            // QUERY Warehouse.GetPurchaseOrderLines
            let result = await api.get(`/warehouse/receiving/po-details/${state.currentEditRow.docEntry}`, {
                params: {
                    docKey: state.currentEditRow.docKey
                }
            });
            //console.log(result)
            console.log(result.detailLines.recordset)
            dispatch(actions.setState({ detailLines: result.detailLines.recordset, modalType: ___.PURCHASE_ORDER }));
        } catch (err) {
            console.error(err);
        }
        dispatch(actions.setState({ loading: false }));
    },

    getIncomingPROSODetails: () => async (dispatch, getState) => {
        console.log('[Incoming.redux.js] getIncomingPROSODetails()')
        const state = getState().warehouse;
        dispatch(actions.setState({ loading: true }));
        //console.log(state.currentEditRow)
        //console.log(state.currentEditRow.docKey)
        //console.log(state.currentEditRow.docEntry)
        //console.log(typeof state.currentEditRow.docKey)

        try {
            // QUERY Warehouse.GetPROFinishedGood
            let result = await api.get(`/warehouse/receiving/pro-so-details/${state.currentEditRow.docEntry}`, {
                params: {
                    docKey: state.currentEditRow.docKey,
                },
            });
            //console.log(result)
            console.log(result.detailLines.recordset)
            dispatch(actions.setState({ detailLines: result.detailLines.recordset, modalType: ___.PRODUCTION_ORDER }));
        } catch (err) {
            console.error(err);
        }
        dispatch(actions.setState({ loading: false }));
    },

    writeProductionOrder: (currentEditRow, editDetailsLines, popSuccessCB) => async (dispatch, getState) => {
        console.log('[Incoming.redux.js] writeProductionOrder()');
        console.log('editDetailsLines', editDetailsLines);
        const state = getState().warehouse;
        //const { currentEditRow } = state;
        console.log(currentEditRow);

        dispatch(actions.setState({ loading: true }));

        try {
            let _filtered = editDetailsLines.filter((r) => (r.orderQty && r.orderQty > 0)); // TODO r.selectedToReceive && 
            //console.log(_filtered);
            let result = await api.put('/warehouse/write-goods-receipt-pro', // TODO default warehouse
                {
                    BaseDocEntry: currentEditRow.docEntry,
                    BaseDocType: 202, // OR currentEditRow.objType
                    Qty: currentEditRow.orderQty,
                    Comments: currentEditRow.notes,
                    selectedWarehouse: currentEditRow.selectedWarehouse,
                    submitRows: _filtered, // not used yet
                });
            console.log(result);
            //console.log(result.data);

            console.log(result.success);
            if (result.success) {
                console.log('success');
                popSuccessCB();
                dispatch(actions.getIncoming());
            }

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write');
            console.error(err);
            dispatch(actions.setState({ loading: false }));
        }
    },

    writePurchaseOrder: (currentEditRow, editDetailsLines, popSuccessCB) => async (dispatch, getState) => {
        console.log('[Incoming.redux.js] writePurchaseOrder()');
        //console.log(currentEditRow);
        //console.log(editDetailsLines);

        const state = getState().warehouse;
        dispatch(actions.setState({ loading: true }));

        let _filtered = editDetailsLines.filter((r) => (r.selectedToReceive && r.orderQty && r.orderQty > 0));
        //console.log(_filtered);

        let sendBody = {
            BaseDocEntry: currentEditRow.docEntry,
            BaseDocType: 22, // OR currentEditRow.objType
            CardCode: currentEditRow.cardCode,
            submitRows: _filtered,
        };

        // TODO_BLANK_NOTES need to prevent writing comments if they are blank, except when they would be intentionally blank
        if (currentEditRow.notes && currentEditRow.notes !== '') {
            sendBody.Comments = currentEditRow.notes;
        }

        try {
            let result = await api.put('/warehouse/write-grpo', // TODO default warehouse
                sendBody);
            console.log(result);

            //console.log(result.success);
            if (result.success) {
                console.log('success');
                popSuccessCB();
                dispatch(actions.getIncoming());
                //dispatch(actions.setState({ purchaseOrders: result.purchaseOrders.recordset }));
            }

            //console.log(result.errorMsg); // errorMsg: "One of the base documents has already been closed"

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write');
            console.error(err);
            dispatch(actions.setState({ loading: false }));
        }
    },

    get_warehouse_options: () => async (dispatch) => {
        console.log('[Incoming.redux.js] get_warehouse_options');
        // TODO we could probably consolidate the three routes/queries into one, but we didnt know where the default warehouse was supposed to come from at the time, so we made separate routes/queries for each.
        dispatch(actions.setState({ loading: true }));

        api.get('/warehouse/get-warehouse-options-po/').then(res => {
            let warehouseOptions = res.options;

            dispatch(actions.setState({ warehouseOptions }));
            dispatch(actions.setState({ loading: false }));
        }).catch(err => {
            console.error(err);
            dispatch(actions.setState({ loading: false }));
        });

    },

    writeSalesOrderNotes: (currentEditRow) => async (dispatch, getState) => {
        console.log('[Incoming.redux.js] writeSalesOrderNotes()');
        console.log(currentEditRow);

        const state = getState().warehouse;

        dispatch(actions.setState({ loading: true }));

        let sendBody = {
            SODocEntry: currentEditRow.SODocEntry,
            orderNotes: currentEditRow.orderNotes,
            internalNotes: currentEditRow.internalNotes,
        };

        try {
            let result = await api.put('/warehouse/write-so-notes',
                sendBody);

            if (result.success) {
                console.log('success');
                // stitch the notes back into the current rows and detail rows
                const updatedOrders = state.originalOrders.map(order => {
                    if (order.docEntry === currentEditRow.docEntry) {
                        return { ...order, ...currentEditRow };
                    }
                    return order;
                });
                dispatch(actions.setState({
                    originalOrders: updatedOrders,
                    currentEditRow: currentEditRow,
                    loading: false
                }));
            }

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write notes');
            console.error(err);
            dispatch(actions.setState({ loading: false }));
        }
    },

    writeSalesSendTo: (currentEditRow, sendToValue) => async (dispatch, getState) => {
        console.log('[Incoming.redux.js] writeSalesSendTo()');
        console.log(currentEditRow);
        console.log(sendToValue);

        const state = getState().warehouse;

        dispatch(actions.setState({ sendingTo: true }));

        let sendBody = {
            SODocEntry: currentEditRow.SODocEntry,
            sendTo: sendToValue,
        };

        try {
            let result = await api.put('/warehouse/write-so-send-to',
                sendBody);

            if (result.success) {
                console.log('success');

                // stitch the rows new sendToLocation so the filter works without refresh
                const updatedOrders = state.originalOrders.map(order => {
                    if (order.docEntry === currentEditRow.docEntry) {
                        return { ...order, sendToLocation: sendToValue };
                    }
                    return order;
                });

                dispatch(actions.setState({
                    originalOrders: updatedOrders,
                    currentEditRow: { ...currentEditRow, sendToLocation: sendToValue },
                    sendingTo: false
                }));
            }

        } catch (err) {
            console.error((result & result.errorMsg) ? result.errorMsg : 'Could not Write Send To');
            console.error(err);
            dispatch(actions.setState({ sendingTo: false }));
        }
    },

    sendShippingDetails: (currentEditRow) => async (dispatch, getState) => {
        console.log('[Incoming.redux] sendShippingDetails')
        console.log(currentEditRow)
        try {
            dispatch(actions.setState({ loading: true }));

            let sendBody = {
                docEntry: currentEditRow.SODocEntry, // IMPORTANT, not docEntry
                has_split_ship: currentEditRow.has_split_ship,
                free_freight: currentEditRow.free_freight,
                has_product_for_fulfillment: currentEditRow.has_product_for_fulfillment,
                group_by: currentEditRow.group_by,
                specialInvInstructions: currentEditRow.specialInvInstructions,
            };

            let result = await api.put('/orders/order/update_shipping',
                sendBody
            );
            console.log(result)

            message.info('Shipping detail successfully updated.');
        } catch (err) {
            console.log('Failed to update shipping detail', err);
            message.error('Failed to update shipping detail. ', err);
        }
        dispatch(actions.setState({ loading: false }));
    },
};
